import R from 'ramda';
import { validateObject, validateField } from 'common/validation';

const dissertationInfoConstraints = {
  'language.code': {
    presence: {
      message: '^Primary language is required',
    },
  },
  title: {
    presence: {
      message: '^A title is required',
    },
  },
  abstract: {
    presence: {
      message: '^An abstract is required',
    },
    // length: {
    //   minimum: 256,
    //   tooShort: '^Your abstract is too short, it needs to be at least 200 characters',
    // }
  },
  institutionName: {
    presence: {
      message: '^Institution/University is required',
    },
  },
  manuscriptCompletionYear: {
    format: {
      allowEmpty: false,
      pattern: /^(19|20)[0-9]{2}$/,
      message: '^Invalid year',
    },
  },
  'degreeAwarded.degreeId': {
    presence: {
      message: '^Please choose an awarded degree',
    },
  },
  'department.departmentId': {
    presence: {
      message: '^Please select a department',
    },
  },
  'primaryCategory.categoryId': {
    presence: {
      message: '^Please choose a primary category',
    },
  },
  'licenseType.licenseTypeId': {
    presence: {
      message: '^A license type is required',
    },
  },
};

const reduceWithIndex = R.addIndex(R.reduce);

export const validateDissertationInfoField = (field, value, errors = {}) =>
  validateField(dissertationInfoConstraints, field, value, errors);

const validateCommitteeMember = R.curry((field, member, errors) => {
  if (R.isEmpty(member.firstName) && !R.isEmpty(member.lastName)) {
    return R.assoc(`${field}.firstName`, ['First name is required'], errors);
  } else if (!R.isEmpty(member.firstName) && R.isEmpty(member.lastName)) {
    return R.assoc(`${field}.lastName`, ['Last name is required'], errors);
  } else {
    return errors;
  }
});

const validateAdvisorOrSupervisor = R.curry((dissertationInfo, errors) => {
  const { advisor, supervisor } = dissertationInfo;

  if (
    R.isEmpty(advisor.firstName) &&
    R.isEmpty(advisor.lastName) &&
    R.isEmpty(supervisor.firstName) &&
    R.isEmpty(supervisor.lastName)
  ) {
    return R.pipe(
      R.assoc('advisor.firstName', ['An advisor or a supervisor is required']),
      R.assoc('advisor.lastName', ['An advisor or a supervisor is required']),
      R.assoc('supervisor.firstName', [
        'A supervisor or an advisor is required',
      ]),
      R.assoc('supervisor.lastName', [
        'A supervisor or an advisor is required',
      ]),
    )(errors);
  } else {
    return errors;
  }
});

const validateCommitteeMembers = R.curry((dissertationInfo, errors) =>
  reduceWithIndex(
    (errors, member, index) =>
      validateCommitteeMember(`committeeMember[${index}]`, member, errors),
    errors,
    dissertationInfo.committeeMembers,
  ),
);

export const validateDissertationInfo = dissertationInfo =>
  R.pipe(
    validateObject(dissertationInfoConstraints),
    validateAdvisorOrSupervisor(dissertationInfo),
    validateCommitteeMember('advisor', dissertationInfo.advisor),
    validateCommitteeMember('supervisor', dissertationInfo.supervisor),
    validateCommitteeMembers(dissertationInfo),
  )(dissertationInfo);



// WEBPACK FOOTER //
// ./src/dissertation-info/dissertationValidation.js